module.exports = __webpack_public_path__ + "assets/img/activity-time-59ed7b31.png";